import Scheduler from "molecule/scheduler/Scheduler";
import { FC, RefObject } from "react";
import Avatar from "../Avatar/Avatar";
import Translate from "../Translate/Translate";
import { AvailabilitySection } from "./AppointmentScheduler.styled";

const SelectProviderSection: FC<{
  show: boolean;
  sectionRef: RefObject<HTMLDivElement | null>;
}> = ({ show, sectionRef }) => {
  if (!show) {
    return null;
  }

  return (
    <AvailabilitySection ref={sectionRef}>
      <h3>
        <Translate msg="appointment.schedule.select_provider" />
      </h3>
      <Scheduler view="pick-provider" avatar={(id) => <Avatar id={id} />} />
    </AvailabilitySection>
  );
};

export default SelectProviderSection;
